module.exports = __webpack_public_path__ + "img/secondDeposits.f2dfc238.svg";